<div class="row">
  <div class="col-md-8">
      <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons"></i>
            </div>
            <h4 class="card-title">Add new folder</h4>
          </div>
          <div class="card-body">

<div mat-dialog-content>

     <form #userNewForm="ngForm">
                  <div class="row">
                    <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating">Folder Name</label>
                    <input type="text" class="form-control" name="company" #company="ngModel" [(ngModel)]="this.folder.name" required>
                  </div>
                </div>
              
              
              </div>

              
    
          
             
              <div class="row">
                
               
                
              </div>
         
                </form>
                
  </div>
      </div>
  </div>
 
</div>

  <div class="col-md-4">
   

    

       <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons"></i>
            </div>
            <h4 class="card-title">Authorize User</h4>
          </div>
          <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                  <div class="form-group">
                   <div  class="form-group" *ngIf="loading == false">
                 

                                 <mat-form-field class="example-full-width">
    <input type="text" [(ngModel)]="this.folder.user_id" placeholder="Select"  aria-label="Select" matInput [formControl]="myControlClientes" [matAutocomplete]="autoClientes" id="nameCliente">
    <mat-autocomplete  #autoClientes="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredClientes | async" [value]="option">
        
        {{option.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button (click)="selectUserPermission()" class="btn btn-success" >Add user</button>
<div class="col-md-12">
                        
                        Authorized Users:
                        <ul style="list-style: none;" id="listausuarios">
                          <li id="{{permission}}" *ngFor="let permission of permissionsShow"><i style="color: green" class="material-icons">person</i> {{permission}}  <i style="color: red" (click)="deletePermiso(permission)" class="material-icons">
delete_forever
</i></li>
                    
                    </ul>
                    </div>

                  </div>
                  <mat-progress-bar style="width: 80%" *ngIf="loading" id="loadingbar" mode="indeterminate"></mat-progress-bar>
                  </div>
                </div>
                </div>

                       
                          
          </div>
      </div>
  </div>



 
<div>
 <div mat-dialog-actions>

  <button mat-button class="btn btn-success" [mat-dialog-close]="this.folder" cdkFocusInitial>Save</button>
</div>
